module.exports = __webpack_public_path__ + "assets/img/logo2.a832f9e5.png";